import { useState, useEffect } from "react";
import { useAuth } from "@/hooks/useAuth";
import { useMemberPermissions } from "@/hooks/useMemberPermissions";

export type UserRole = "owner" | "admin" | "member" | null;

/**
 * OPTIMIZED: No longer makes its own DB query.
 * Derives role entirely from useMemberPermissions which already fetches workspace_members.
 */
export const useUserRole = () => {
  const { user } = useAuth();
  const { role: memberRole, loading: memberLoading } = useMemberPermissions();
  
  const role = (memberRole as UserRole) || null;
  const loading = !user ? false : memberLoading;
  const isAdmin = role === "admin" || role === "owner";
  const isOwner = role === "owner";

  return { role, isAdmin, isOwner, loading };
};
